var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"pa-2",attrs:{"color":"info","dark":"","absoulte":""}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('v-spacer'),_c('div',[_c('strong',[_vm._v("Vilsons Shipping Pte Ltd. |")]),_vm._v(" © "+_vm._s(new Date().getFullYear()))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }